<div class="activity-dialog-wrapper mat-elevation-z10">
  <div class="flex flex-row content p-8">
    <div class="flex flex-col w-100-percent">
      <!-- Split Pane Content -->
      <div class="split-pane-container">
        <app-activity-left-panel
          [data]="data"
          [activityDetails]="activityDetails"
          [isDataLoading]="isDataLoading"
          [isRefreshing]="isRefreshing"
          (stageTitleSelected)="onStageTitleSelected($event)"
          (stageSelected)="onStageSelected($event)"
          (aborted)="onRefresh()"
          [selectedStage]="selectedStage">
        </app-activity-left-panel>

        <mat-divider [vertical]="true" class="pane-divider pl-8"></mat-divider>

        <app-activity-right-panel
          [selectedStage]="selectedStage"
          [mainData]="activityDetails"
          [stageTitle]="selectedStageTitle"
          [componentsLoading]="isDataLoading"
          [loading]="isRefreshing"
          [tenantId]="data?.tenantId"
          [blueprintName]="data?.blueprintName"
          [instanceName]="data?.instanceName"
          [randomSuffix]="data?.randomSuffix"
          [action]="data?.action"
          (closed)="closeDialog()"
          (refresh)="onRefresh()">
        </app-activity-right-panel>
      </div>
    </div>
  </div>
</div>